(() => {
  /*
   * Renders the AdvantEdge button which calls the AdvantEdge modal.
   */
  angular
    .module('app.components')
    .directive('eventFunnel', ['$sce', '$timeout', ($sce, $timeout) => {
      const KEY_FUNNEL = 'eventFunnel';

      const pathBuilder = {
        //generates a string representing a single svgPath
        buildSvgPath: (topLeft, topRight, bottomRight, bottomLeft) => (
          `M100,${bottomRight}C50,${bottomRight},50,${bottomLeft},0,${bottomLeft}V${topLeft}
           c50,0,50,${topRight - topLeft},100,${topRight - topLeft}V${bottomRight}z`
        ),
        // Function for building back, mid and front paths, returns 3 paths due to the transparent "trail"
        buildSvgPaths: function (percentageLeft, percentageRight) {
          // Define SVG graph "trail" height (the semi-transparent trail effect)
          const trailHeight = 5;

          // Base calculations needed for defining SVG coordinates
          const backBaseTop = 0;
          const backBaseBottom = 100 + (4 * trailHeight);
          const midBaseTop = trailHeight;
          const midBaseBottom = 100 + (3 * trailHeight);
          const frontBaseTop = 2 * trailHeight;
          const frontBaseBottom = 100 + (2 * trailHeight);

          // Make sure line always has some visual height
          const remainingHeightLeft = (100 - Math.max(percentageLeft, 2)) / 2;
          const remainingHeightRight = (100 - Math.max(percentageRight, 2)) / 2;

          // Calculate coordinates for back
          const backTopLeftPoint = backBaseTop + remainingHeightLeft;
          const backTopRightPoint = backBaseTop + remainingHeightRight;
          const backBottomRightPoint = backBaseBottom - remainingHeightRight;
          const backBottomLeftPoint = backBaseBottom - remainingHeightLeft;

          // Calculate coordinates for mid
          const midTopLeftPoint = midBaseTop + remainingHeightLeft;
          const midTopRightPoint = midBaseTop + remainingHeightRight;
          const midBottomRightPoint = midBaseBottom - remainingHeightRight;
          const midBottomLeftPoint = midBaseBottom - remainingHeightLeft;

          // Calculate coordinates for front
          const frontTopLeftPoint = frontBaseTop + remainingHeightLeft;
          const frontTopRightPoint = frontBaseTop + remainingHeightRight;
          const frontBottomRightPoint = frontBaseBottom - remainingHeightRight;
          const frontBottomLeftPoint = frontBaseBottom - remainingHeightLeft;

          // Build back SVG path
          const backPath = this.buildSvgPath(
            backTopLeftPoint,
            backTopRightPoint,
            backBottomRightPoint,
            backBottomLeftPoint);

          // Build mid SVG path
          const midPath = this.buildSvgPath(
            midTopLeftPoint,
            midTopRightPoint,
            midBottomRightPoint,
            midBottomLeftPoint);

          // Build front SVG path
          const frontPath = this.buildSvgPath(
            frontTopLeftPoint,
            frontTopRightPoint,
            frontBottomRightPoint,
            frontBottomLeftPoint);

          return [
            backPath,
            midPath,
            frontPath
          ];
        },
        buildSvgPathsFromFunnelEvents: function(funnelEvents) {
          const funnelCounts = _.pluck(funnelEvents, 'count');
          const highestCount = _.max(funnelCounts);
          const graphHeightArray = _.map(funnelCounts, val => (val / highestCount) * 100);
          const funnelLength = funnelEvents.length;

          return _.map(graphHeightArray, (value, index, list) => {
            const graphHeightLeft = value;
            const graphHeightRight = (index === funnelLength - 1 ? value : list[index + 1]);

            return pathBuilder.buildSvgPaths(graphHeightLeft, graphHeightRight);
          });
        },
        buildEmptySvgPathsFromFunnelEvents: function(funnelEvents) {
          const emptyPath = "M100,60c-50,0-50,0-100,0l0,0C50,60,50,60,100,60L100,60z";

          return _.map(funnelEvents, () => [emptyPath, emptyPath, emptyPath]);
        }
      };

      function delayedRender(scope, milliseconds) {
        $timeout(() => {
          scope.funnel.redraw();
        }, scope.animate ? undefined : scope.delayedRenderMs);
      }

      function canCreateStepsOrder(order, scope) {
        return !!scope.funnel.funnelEvents.some(item => order.includes(item.eventType));
      }

      function getEventsOrder(scope) {
        const json = localStorage.getItem(KEY_FUNNEL);
        const order = json && JSON.parse(json);

        if (order && canCreateStepsOrder(order, scope)) {
          return order;
        }

        return scope.funnelEventsOrder;
      }

      // function saveInOrder(scope) {
      //   const write = scope.funnelEventsOrder.reduce((memo, type) => {
      //     const event = scope.funnel.funnelEvents.find(item => item.eventType === type);
      //     return event ? [...memo, type] : memo
      //   }, []);
      //   localStorage.setItem(KEY_FUNNEL, JSON.stringify(write));
      // }

      function saveAsIs(scope) {
        const write = scope.funnel.funnelEvents.reduce((memo, item) => [...memo, item.eventType], []);
        localStorage.setItem(KEY_FUNNEL, JSON.stringify(write));
      }

      function addInOrder(scope) {
        scope.allowedEvents.forEach(event => {
          event.disabled = false;
        });

        scope.funnel.funnelEvents = getEventsOrder(scope).reduce((memo, type) => {
          const event = _.find(scope.funnelEvents, item => item.eventType === type);
          if (event) {
            event.disabled = true;
            return [...memo, event];
          }
          return memo;
        }, []);

        scope.funnel.recomputePercentages();
      }

      function addStepInOrder(step, scope) {
        const index = scope.funnelEventsOrder.indexOf(step.eventType);
        step.disabled = true
        scope.funnel.funnelEvents.splice(index, 0, step);

        scope.funnel.recomputePercentages();
      }

      return {
        restrict: 'E',
        scope: {
          funnelEventsOrder: '=',
          funnelEvents: '=',
          allowedEvents: '=',
          animate: '=',
          redraw: '@',
        },
        templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/charts/eventFunnel.html'),
        controller: ['$scope', function ($scope, $element) {
          $scope.delayedRenderMs = 200;

          if ($scope.animate) {
            $scope.svgPaths = pathBuilder.buildEmptySvgPathsFromFunnelEvents($scope.funnelEvents);
          } else {
            $scope.svgPaths = pathBuilder.buildSvgPathsFromFunnelEvents($scope.funnelEvents);
          }
        }],
        link: function (scope, element, attrs, controller) {
          attrs.$observe('redraw', () => {
            addInOrder(scope);
            delayedRender(scope);
          });

          scope.funnel = {
            funnelEvents: [],
            element: element.find('.funnel'),
            // Define Snap.svg easing type and animation timing
            easingType: mina.easeinout,
            timing: {
              mid: 600,
              back: 700,
              front: 500
            },
            makeVisible: function () {
              this.element.addClass('is-visible');
            },
            redraw: function () {
              const funnel = this;
              const funnelEvents = getEventsOrder(scope).reduce((memo, type) => {
                const event = _.find(scope.funnelEvents, item => item.eventType === type);
                return event ? [...memo, { count: event.count }] : memo;
              }, []);

              // Iterate through funnel items and compute graph heights
              let funnelStepItems = funnel.element.find('.funnel-step');

              //filter out elements marked for removal by angular
              funnelStepItems = funnelStepItems.filter(index => !funnelStepItems[index].$$NG_REMOVED);

              const funnelStepSvgPaths = pathBuilder.buildSvgPathsFromFunnelEvents(funnelEvents);

              funnelStepItems.each(index => {
                const svgPaths = funnelStepSvgPaths[index];
                const s = Snap(`#funnel-graph-${index}`);

                if (s) {
                  s.select('.front').animate({
                    d: svgPaths[2]
                  }, funnel.timing.front, funnel.easingType);

                  s.select('.mid').animate({
                    d: svgPaths[1]
                  }, funnel.timing.mid, funnel.easingType);

                  s.select('.back').animate({
                    d: svgPaths[0]
                  }, funnel.timing.back, funnel.easingType);
                }
              });
            },
            recomputePercentages: function () {
              if (!this.funnelEvents[0]) return;

              const firstCount = this.funnelEvents[0].count;
              let prevCount = firstCount;

              angular.forEach(this.funnelEvents, function (event) {
                event.rate = (event.count / firstCount) * 100;
                event.gain = ((event.count - prevCount) / prevCount) * 100;
                event.disabled = true;
                prevCount = event.count;
              });
            },
            addStep: function (eventType) {
              addStepInOrder(eventType, scope);
              saveAsIs(scope);
            },
            removeStep: function (eventType) {
              // delete funnelStep object first to avoid graphical glitch
              const index = this.funnelEvents.indexOf(eventType);
              const funnelStepElement = this.element.find(`[id='funnel-step-${index}']`);
              funnelStepElement.addClass('is-removed').removeClass('is-visible');
              // After transition has finished remove the funnel step
              $timeout(() => {
                funnelStepElement.remove();
              }, 200);

              // now take care of funnel logic for next digest
              this.funnelEvents.splice(index, 1);
              eventType.disabled = false;
              this.recomputePercentages();
              saveAsIs(scope);
            },
            updateStep: function (funnelStep, eventType) {
              // because of how ng-repeat works, the deleted value is only marked with $$NG_REMOVED on
              // the first digest pass
              // so we should delete funnel step object manually to avoid graphical glitch
              const index = this.funnelEvents.indexOf(funnelStep);
              this.element.find(`[id='funnel-step-${index}']`).remove();

              // now take care of funnel logic for next digest
              this.funnelEvents[index] = eventType;
              funnelStep.disabled = false;
              eventType.disabled = true;
              this.recomputePercentages();
              saveAsIs(scope);
            }
          };

          scope.removeStep = function (eventType) {
            scope.funnel.removeStep(eventType);
            delayedRender(scope);
          };

          scope.addStep = function (eventType) {
            scope.funnel.addStep(eventType);
            delayedRender(scope);
          };

          scope.updateStep = function (funnelStep, eventType) {
            scope.funnel.updateStep(funnelStep, eventType);
            delayedRender(scope)
          };

          scope.funnel.makeVisible();
          addInOrder(scope);

          if (scope.animate) {
            delayedRender(scope);
          }
        }
      }
  }]);

})();
